export default __webpack_public_path__ + "static/media/uploadBtn.84f3efe7.svg";